export const qprConstants = {
  QPR_SUCCESS: 'QPR_SUCCESS',
  QPR_FAILURE: 'QPR_FAILURE',
  QPR_DATA_SUCCESS: 'QPR_DATA_SUCCESS',
  QPR_DATA_FAILURE: 'QPR_DATA_FAILURE',
};
